import state from './energy.state'
import mutations from './energy.mutations'
import actions from './energy.actions'

export default {
  state,
  mutations,
  actions
}
